import { server_connection } from 'config';
import { auth } from 'firebase';
// value: value of form field
// functionName: function to be ran for form field
// chars: amount of chars in a textfield

export function validateField(arg, func) {
    switch (func) {
        case ("checkRequiredFilled"):
            {
                return checkRequiredFilled(arg.value);
            }
        case ("checkEmailValid"):
            {
                return checkEmailValid(arg.value)
            }
        case ("checkFieldLength"):
            {
                return checkFieldLength(arg.value, arg.chars)
            }
        case ("checkEmailUnique"):
            {
                return checkEmailUnique(arg.value, arg.id, arg.component)
            }
        case ("checkFieldNotValue"):
            {
                return checkFieldNotValue(arg.value, arg.notValue)
            }
    }
}

export function checkEmailValid(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const status = re.test(String(email).toLowerCase());
    return { status: status, error_message: status ? '' : 'not a valid email' }
}

export function checkRequiredFilled(value) {
    if (value) {
        return { status: true, error_message: '' }
    } else {
        return { status: false, error_message: 'cannot be empty' }
    }
}

export function checkFieldLength(value, chars) {
    if (value.length >= chars) {
        return { status: true, error_message: '' }
    }
    return { status: false, error_message: 'field must be at least ' + chars + ' characters long' }
}

export async function checkEmailUnique(value, id, component) {
    if (!value) {
        return { status: false, error_message: 'email cannot be empty' }
    }
    const bool = await fetch(server_connection + '/auth/check_email_unique/' + value + '/' + id + '/' + component)
        .then((response) => response.json())
    const status = bool.res
    return { status: status, error_message: status ? '' : 'email must be unique' }
    // .then((response) => response.json())
    // .then((bool) => {
    //     console.log(bool)
    //     return bool
    // });
}

export function checkFieldNotValue(value, notValue) {
    if (value === notValue) {
        return  { status: false, error_message: 'Must pick a role' }
    }
    return { status: true, error_message: '' }
}


// WEBPACK FOOTER //
// src/main/components/utils/FormValidations.js